import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=171e8410&"
import script from "./tiktok.vue?vue&type=script&lang=js&"
export * from "./tiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports